import { Link } from "react-router-dom";
import { quickNews, articles } from "@/mocks/news";

export default function LiveFeed() {
  const related = articles.slice(4, 7);

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-8 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 mb-2">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
              快讯滚动播报
            </h2>
            <p className="mt-2 text-sm text-foreground-600 font-label max-w-xl">
              不用到处翻，今天值得关注的动态按时间顺序排在这里，往下滑就能一路看完。
            </p>

            <ol className="mt-7 relative pl-6 border-l border-background-300">
              {quickNews.map((item, index) => (
                <li key={`${item.time}-${index}`} className="relative pb-6 last:pb-0">
                  <span
                    className={`absolute -left-[27px] top-1 w-3 h-3 rounded-full border-2 border-background-100 ${
                      index === 0 ? "bg-primary-500" : "bg-background-400"
                    }`}
                  ></span>
                  <div className="flex items-start gap-3">
                    <time className="shrink-0 text-xs text-primary-600 font-label tabular-nums pt-0.5 w-11">
                      {item.time}
                    </time>
                    <p className="text-sm text-foreground-800 leading-relaxed font-label">
                      {item.text}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
            <Link
              to="/news"
              className="mt-7 inline-flex items-center gap-1.5 text-sm font-label text-secondary-600 hover:text-secondary-700 transition-colors cursor-pointer"
            >
              查看全部快讯
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="rounded-xl bg-background-50 border border-background-200 p-5 md:p-6 h-fit lg:sticky lg:top-24">
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">
              正在被讨论
            </h3>
            <div className="space-y-4">
              {related.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex gap-3 cursor-pointer"
                >
                  <div className="w-20 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={`${article.title} - 独家吃瓜`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="min-w-0">
                    <h4 className="text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors font-label">
                      {article.title}
                    </h4>
                    <p className="mt-1 text-[11px] text-foreground-500 font-label">
                      {article.categoryName} · {article.time}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}